<ng-container #formDirective="parent-form" thr-parent-form>
    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                <ng-container [ngSwitch]="client.type">
                    <span *ngSwitchCase="ClientType.DISABLED">{{ 'form.disabled-data' | translate }}</span>
                    <span *ngSwitchCase="ClientType.MINOR">{{ 'form.minor-data' | translate }}</span>
                </ng-container>
                <ng-container [ngSwitch]="client.relation">
                    <span class="text-lowercase" *ngSwitchCase="ClientRelation.AUTHORIZED">&nbsp;{{ 'form.authorized' | translate }}</span>
                    <span class="text-lowercase" *ngSwitchDefault>
                        <ng-container *ngIf="client.isSoleHolder">&nbsp;{{ 'form.holder' | translate }}</ng-container>
                        <ng-container *ngIf="!client.isSoleHolder">&nbsp;{{ 'form.co-holder' | translate }}</ng-container>
                    </span>
                </ng-container>
            </h3>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-auto mb-4 mb-sm-0 mr-sm-4">
            <mat-slide-toggle name="fdompIsSpanish" color="blue-gray" labelPosition="before" [disabled]="true" [(ngModel)]="client.isSpanish">
                {{ 'form.you-are-spanish' | translate }}
            </mat-slide-toggle>
        </div>
        <div class="col-12 col-sm-auto">
            <mat-slide-toggle name="fdompIsResident" color="blue-gray" labelPosition="before" [disabled]="true" [(ngModel)]="client.isResident">
                {{ 'form.you-are-resident' | translate }}
            </mat-slide-toggle>
        </div>
    </div>

    <hr class="mt-4 mb-3" />

    <div class="row">
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdompCitizenship" [placeholder]="'form.citizenship' | translate" required [errorStateMatcher]="errorMatcher" [disabled]="isDisabled || client.isSpanish || isDisabledSubmit" [(ngModel)]="client.citizenship" #citizenCtrl="ngModel">
                    <ng-template ngFor let-country [ngForOf]="countries">
                        <mat-option [value]="country.id.value" *ngIf="(!client.isSpanish && country.id.value !== 'ES') || client.isSpanish">
                            {{ country.name }}
                        </mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="citizenCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdompCountryOfResidence" [placeholder]="'form.country-of-residence' | translate" required [errorStateMatcher]="errorMatcher" [disabled]="isDisabled || client.isResident || isDisabledSubmit" [(ngModel)]="client.countryOfResidence" #countryOfResidenceCtrl="ngModel">
                    <ng-template ngFor let-country [ngForOf]="countries">
                        <mat-option [value]="country.id.value" *ngIf="(!client.isResident && country.id.value !== 'ES') || client.isResident">
                            {{ country.name }}
                        </mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="countryOfResidenceCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-6 col-lg-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdompDocumentType" [placeholder]="'form.document' | translate" [disabled]="true" [(ngModel)]="client.docType">
                    <ng-template ngFor let-type [ngForOf]="client.allowedDocTypes">
                        <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                    </ng-template>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
            <ng-container [ngSwitch]="client.docType">
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.DNI">
                    <mat-label>{{ 'form.document-types.DN' | translate }}</mat-label>
                    <input name="fdompDocument" matInput [placeholder]="'form.hints.dni' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIF">
                    <mat-label>{{ 'form.document-types.NF' | translate }}</mat-label>
                    <input name="fdompDocument" matInput [placeholder]="'form.hints.nif' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.CIF">
                    <mat-label>{{ 'form.document-types.CI' | translate }}</mat-label>
                    <input name="fdompDocument" matInput [placeholder]="'form.hints.cif' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE">
                    <mat-label>{{ 'form.document-types.NR' | translate }}</mat-label>
                    <input name="fdompDocument" matInput [placeholder]="'form.hints.nie' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE_NOT_RESIDENT">
                    <mat-label>{{ 'form.document-types.NN' | translate }}</mat-label>
                    <input name="fdompDocument" matInput [placeholder]="'form.hints.nie' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT">
                    <input name="fdompDocument" matInput [placeholder]="'form.document-types.PN' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT_LATIN">
                    <input name="fdompDocument" matInput [placeholder]="'form.document-types.PL' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PERMISSION">
                    <input name="fdompDocument" matInput [placeholder]="'form.document-types.PR' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT">
                    <input name="fdompDocument" matInput [placeholder]="'form.document-types.TR' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                    <input name="fdompDocument" matInput [placeholder]="'form.document-types.DI' | translate" [disabled]="true" [(ngModel)]="client.docId" />
                </mat-form-field>
            </ng-container>
        </div>
        <div class="col-12 col-sm-6 col-lg-3">
            <!-- TODO: BUG with required dynamic in child form component https://github.com/angular/angular/issues/23657 -->
            <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="!client.docExpirationDatePermanent">
                <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                <input name="fdompDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" required maxlength="10" [disabled]="isDisabled || isDisabledSubmit" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel"
                />
                <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                <mat-datepicker #documentPicker [disabled]="isDisabled || isDisabledSubmit"></mat-datepicker>
                <mat-error *ngIf="!documentExpirationCtrl.valid">
                    {{ 'form.validation.expired-document-date' | translate }}
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.docExpirationDatePermanent">
                <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                <input name="fdompDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" disabled [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel" />
                <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                <mat-datepicker #documentPicker disabled></mat-datepicker>
                <mat-error *ngIf="!documentExpirationCtrl.valid">
                    {{ 'form.validation.expired-document-date' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-lg-2 mb-3 mb-sm-0 mt-sm-2 mt-md-3">
            <mat-checkbox name="fdompPermanentValidity" [disabled]="isDisabled || client.type === ClientType.MINOR || isDisabledSubmit" [(ngModel)]="client.docExpirationDatePermanent">
                {{ 'form.permanent-validity' | translate }}
            </mat-checkbox>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input name="fdompName" matInput [placeholder]="'form.name' | translate" required maxlength="20" [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.name" #nameCtrl="ngModel" />
                <mat-error *ngIf="nameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input name="fdompSurname" matInput [placeholder]="'form.surname' | translate" required maxlength="60" [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.surname" #surnameCtrl="ngModel" />
                <mat-error *ngIf="surnameCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdompGenderType"
                    [placeholder]="'form.gender' | translate"
                    [disabled]="isDisabled"
                    [(ngModel)]="client.gender"
                    required
                    #genderCtrl="ngModel">
                    <ng-template ngFor let-type [ngForOf]="client.allowedGenderTypes">
                        <mat-option [value]="type">{{ 'form.gender-types.' + type | translate }}</mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="genderCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdonpMaritalStatusType"
                    [placeholder]="'form.marital-status' | translate"
                    [disabled]="isDisabled"
                    [(ngModel)]="client.maritalStatus"
                    required
                    #maritalStatusCtrl="ngModel">
                    <ng-template ngFor let-type [ngForOf]="client.allowedMaritalStatusTypes">
                        <mat-option [value]="type">{{ 'form.marital-status-types.' + type | translate }}</mat-option>
                    </ng-template>
                </mat-select>
                <mat-error *ngIf="maritalStatusCtrl.hasError('required')">
                    {{ 'form.validation.required'|translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <ng-container *ngIf="client.type === ClientType.MINOR">
            <div class="col-12 col-sm-6 col-lg-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                    <input name="fdompBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" ofMinorAge [placeholder]="'form.hints.date' | translate" [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.birthDate"
                        #birthDateCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker [disabled]="isDisabled || isDisabledSubmit"></mat-datepicker>
                    <mat-error *ngIf="birthDateCtrl.hasError('ofMinorAge')">
                        {{ 'form.validation.of-minor-age' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!birthDateCtrl.hasError('ofMinorAge') && !birthDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </ng-container>
        <ng-container *ngIf="client.type !== ClientType.MINOR">
            <div class="col-12 col-sm-6 col-lg-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                    <input name="fdompBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" [placeholder]="'form.hints.date' | translate" [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.birthDate"
                        #birthDateCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker [disabled]="isDisabled || isDisabledSubmit"></mat-datepicker>
                    <mat-error *ngIf="!birthDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </ng-container>
    </div>

    <div class="row" *ngIf="client.type !== ClientType.MINOR">
        <div class="col-12 col-sm-6">
            <mat-checkbox name="fdompNotPhone" [disabled]="isDisabled" [(ngModel)]="client.phoneExonerate">
                {{ 'form.not-phone' | translate }}
            </mat-checkbox>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdompPhone" matInput [placeholder]="'form.phone' | translate" required minlength="9" pattern="[\d\+]+" [phoneExists]="true" [clientCode]="client.encryptedCode" [disabled]="client.phoneExonerate || isDisabled" [(ngModel)]="client.phone" #phoneCtrl="ngModel"
                        />
                        <mat-error *ngIf="(phoneCtrl.hasError('minlength') || phoneCtrl.hasError('pattern')) && !phoneCtrl.hasError('required')">
                            {{ 'form.validation.invalid.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneCtrl.hasError('phoneExists') && !phoneCtrl.hasError('required')">
                            {{ 'form.validation.phone-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdompPhoneConfirm" matInput [placeholder]="'form.phone-confirm' | translate" required minlength="9" pattern="[\d\+]+" [equalTo]="phoneCtrl" [disabled]="client.phoneExonerate || isDisabled" [(ngModel)]="client.phoneConfirm" #phoneConfirmCtrl="ngModel"
                        />
                        <mat-error *ngIf="
                                (phoneConfirmCtrl.hasError('minlength') || phoneConfirmCtrl.hasError('pattern')) &&
                                !phoneConfirmCtrl.hasError('required')
                        ">
                            {{ 'form.validation.invalid.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                phoneConfirmCtrl.hasError('equalTo') &&
                                !phoneConfirmCtrl.hasError('minlength') &&
                                !phoneConfirmCtrl.hasError('pattern') &&
                                !phoneConfirmCtrl.hasError('required')
                        ">
                            {{ 'form.validation.equalTo.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="phoneConfirmCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-6">
            <mat-checkbox name="fdompNotEmail" [disabled]="isDisabled" [(ngModel)]="client.emailExonerate">
                {{ 'form.not-email' | translate }}
            </mat-checkbox>
            <div class="row">
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdompEmail" matInput [placeholder]="'form.email' | translate" required emailWithDot [emailExists]="true" [clientCode]="client.encryptedCode" [disabled]="client.emailExonerate || isDisabled" [(ngModel)]="client.email" #emailCtrl="ngModel"
                        />
                        <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')">
                            {{ 'form.validation.invalid.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailCtrl.hasError('emailExists') && !emailCtrl.hasError('required')">
                            {{ 'form.validation.email-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdompEmailConfirm" matInput [placeholder]="'form.email-confirm' | translate" required emailWithDot [equalTo]="emailCtrl" [disabled]="client.emailExonerate || isDisabled" [(ngModel)]="client.emailConfirm" #emailConfirmCtrl="ngModel" />
                        <mat-error *ngIf="emailConfirmCtrl.hasError('email') && !emailConfirmCtrl.hasError('required')">
                            {{ 'form.validation.invalid.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                emailConfirmCtrl.hasError('equalTo') &&
                                !emailConfirmCtrl.hasError('email') &&
                                !emailConfirmCtrl.hasError('required')
                        ">
                            {{ 'form.validation.equalTo.email' | translate }}
                        </mat-error>
                        <mat-error *ngIf="emailConfirmCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-6">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-12">
                    <mat-form-field class="full-width mb-3 mb-sm-4">
                        <input name="fdonpLandLine" matInput [placeholder]="'form.telephone' | translate" minlength="9" pattern="[\d\+]+" [disabled]="isDisabled" [(ngModel)]="client.landLine" #landLineCtrl="ngModel" />
                        <mat-error *ngIf="(landLineCtrl.hasError('minlength') || landLineCtrl.hasError('pattern')) && !landLineCtrl.hasError('required')">
                            {{ 'form.validation.invalid.phone' | translate }}
                        </mat-error>
                        <mat-error *ngIf="landLineCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>
        </div>

    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.country-city-birth' | translate }}
            </h3>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <mat-select name="fdompCountry" [placeholder]="'form.country' | translate" required [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.countryOfBirth" #countryCtrl="ngModel">
                    <mat-option *ngFor="let country of countries" [value]="country.id.value">
                        {{ country.name }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="countryCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-12 col-sm-6 col-lg-4">
            <mat-form-field class="full-width mb-3 mb-sm-4">
                <input name="fdompCity" maxlength="40" matInput [placeholder]="'form.city' | translate" required [disabled]="isDisabled || isDisabledSubmit" [(ngModel)]="client.cityOfBirth" #cityCtrl="ngModel" />
                <mat-error *ngIf="cityCtrl.hasError('required')">
                    {{ 'form.validation.required' | translate }}
                </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold mb-0">
                {{ 'full-data.tax-residence' | translate }}
            </h3>
            <mat-hint class="d-block mat-caption font-italic mb-3">{{ 'full-data.has-to-match-identification-address' | translate }}
            </mat-hint>
        </div>
        <div class="col-12">
            <thr-full-data-form-address [isDisabled]="isDisabled" [address]="client.habitualResidence" (change)="onHabitualResidenceChange()"></thr-full-data-form-address>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h3 class="mat-subheading-1 text-blue font-weight-bold">
                {{ 'full-data.mail-residence-question' | translate }}
            </h3>
            <mat-radio-group name="fdompYesNo" [(ngModel)]="client.isEqualMailAddress" (ngModelChange)="onEqualMailAddressChange()" [required]="true" [disabled]="isDisabled">
                <div class="row">
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdompNo" class="mb-3 mb-sm-4" color="blue-gray" [value]="false">
                            {{ 'general.no' | translate }}
                        </mat-radio-button>
                    </div>
                    <div class="col-6 col-sm-3">
                        <mat-radio-button name="fdompYes" class="mb-3 mb-sm-4" color="blue-gray" [value]="true">
                            {{ 'general.yes' | translate }}
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div class="col-12" *ngIf="!client.isEqualMailAddress">
            <thr-full-data-form-address [isDisabled]="isDisabled" [address]="client.mailResidence"></thr-full-data-form-address>
        </div>
    </div>

    <div class="row justify-content-end" *ngIf="!isDisabled && !isDisabledSubmit">
        <div class="col-12 col-sm-6 col-md-4">
            <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid">
                {{ 'general.save' | translate }}
            </button>
        </div>
    </div>
</ng-container>
